import { ColorblindDarkTheme } from "../.internal/themes/ColorblindDarkTheme";
export default ColorblindDarkTheme;
